<template>
  <div>
    <div class="mt-5" v-if="poolMembership">
      <Invites />
      <v-container>
        <v-col offset-md="3" :md="6">
          <v-select v-model="poolId"
            :items="memberPools" item-text="poolName" item-value="poolId"
            label="Pool Name" @change="poolChange">
          </v-select>
          <v-divider> </v-divider>
          <div v-if="poolObject.poolName">
            <h2 class="primary--text text-center">{{poolObject.poolName}}</h2>
            <h3 class="primary--text text-center">Points Table</h3>
            <v-row>
              <v-col cols="8"><h3 class="primary--text">Name</h3></v-col>
              <v-col cols="4"><h3 class="primary--text text-center">Points</h3></v-col>
            </v-row>
            <div v-for="point in userPoints" :key="point.userId.userId">
              <v-row>
                <v-col cols="8">
                  <router-link :to="{ name: 'view-entry', params: { poolObject: poolObject, userObject: point.userId}}">
                    {{ point.userId.userFName }} {{ point.userId.userLName }}
                  </router-link>
                </v-col>
                <v-col class="text-center" cols="4">
                  {{ point.points }}
                </v-col>
              </v-row>
            </div>
            <v-btn color="primary">Refresh Comments</v-btn>
            <v-text-field label="Enter Comments and press Enter" @keyup.enter="addComments"
              v-model="commentText" />
            <div v-for="(comment, index) in poolComments" :key="index">
              
              <p class="text-left text-caption mb-n1">
                {{ comment.userFName }} {{ comment.userLName }} @ {{ comment.commentTime }}
              </p>
              <p class="text-left text-body-1 mt-2">
                {{ comment.commentText }}
              </p>
              
            </div>
          </div>
        </v-col>
      </v-container>
    </div>
    <div v-else>
      <Invites />
      <v-card width="400" class="mx-auto mt-5">
        <v-card-title>
          <h1 class="primary--text">Start with</h1>
        </v-card-title>
        <v-card-text>
          <v-btn block color="primary" to="/tournament">Create Tournament</v-btn>
          <v-btn class="mt-3" block color="primary" to="/pool">Start Pool</v-btn>
          <v-btn class="mt-3" block color="primary" to="/invite">Invite Friends</v-btn>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios';
import Invites from '@/components/Invites.vue'

export default {
  name: 'mainw',
  components: { Invites },
  computed: {
    ...mapGetters([
      'poolMembership',
      'memberPools', 'memberPoolsLoaded',
      'poolPoints', 'poolPointsLoaded', 
      'poolComments',
    ]),
    userPoints: function() {
      var tempArr = []
      var i=0
      if (this.poolPointsLoaded && this.poolPoints && this.poolPoints) {
        for (i=0; i<this.poolPoints.length; i++) {
          tempArr.push({ 
            userId: { userId: this.poolPoints[i].userId,
                    userFName: this.poolPoints[i].userFName,
                    userLName: this.poolPoints[i].userLName },
              points: this.poolPoints[i].poolPoints 
          })
        }
        tempArr.sort(function(a, b) {
          return (a.points > b.points ? -1: 1)
        })
      } else {
        if (this.poolObject.poolMembers) {
          for (i=0; i<this.poolObject.poolMembers.length; i++) {
            tempArr.push({ userId: this.poolObject.poolMembers[i], points: 0 })
          }
        }
      }
      return tempArr
    }
  },
  watch: {
    memberPoolsLoaded: function() {
      if (this.memberPools.length > 0) {
        if (this.poolId == 0) {
          this.poolId = this.memberPools[0].poolId
          this.poolChange()
        }
      }
    }
  },
  data: () => ({
    poolObject: {},
    poolId: 0,
    commentText: '',
  }),
  created() {
    this.$store.dispatch('getMemberPools')
  },
  methods: {
    poolChange() {
      this.poolObject = this.memberPools.find(element => element.poolId == this.poolId)
      this.$store.dispatch('getPoolPoints', this.poolObject.poolId)
      this.$store.dispatch('getPoolComments', this.poolObject.poolId)
    },
    addComments() {
      var text = this.commentText.trim()
      const token = this.$store.getters.authToken
      var self = this
      if (text !== '') {
        var entry = {
          poolId: this.poolObject.poolId,
          commentText: text
        }
        if (token) {
          const header = { 'Content-type': 'application/json', 'x-auth': token }
          axios.post('/api/poolComment', JSON.stringify(entry), { headers: header })
          .then(() => {
            self.commentText = ''
            self.$store.dispatch('getPoolComments', self.poolObject.poolId)
          })
          .catch(error => {
            alert(error.response.data.err)
          })
        }
      }
    }
  }
}
</script>
